import axios from 'axios'
import { openNewTabBlobFile } from 'utils/helper'

export const getProformaOrders = ({ params }) => {
  return axios.get(`/finance/proformaOrders`, { params })
}

export const getProformaOrder = (id, params) => {
  return axios.get(`/finance/proformaOrders/${id}`, { params })
}

export const addProformaOrder = (data) => {
  return axios.post(`/finance/proformaOrders`, data)
}

export const editProformaOrder = (data) => {
  return axios.put(`/finance/proformaOrders/${data.id}`, data)
}

export const deleteProformaOrder = (id) => {
  return axios.delete(`/finance/proformaOrders/${id}`)
}

export const deleteOnAddProformaOrderAttachment = (url) => {
  return axios.delete('/finance/proformaOrders/attachments', { data: { url } })
}

export const deleteOnEditProformaOrderAttachment = (id, url) => {
  return axios.delete(`/finance/proformaOrders/${id}/attachments`, { data: { url } })
}

export const createPdfProformaOrder = (id) => {
  return axios
    .get(`/finance/proformaOrders/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response.data)
      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getProformaOrderEmailTemplate = (id) => {
  return axios.get(`/finance/proformaOrders/${id}/email`)
}

export const sendProformaOrderEmail = (id, data) => {
  return axios.post(`/finance/proformaOrders/${id}/email`, data)
}

export const getProformaOrderPublicUrl = (id) => {
  return axios.get(`/finance/proformaOrders/${id}/publicUrl`)
}

export const getProformaOrderLog = ({ id, params } = {}) => {
  return axios.get(`/finance/proformaOrders/${id}/logs`, { params })
}
